import {
	ENABLE_WABA_ID_DROPDOWN,
	DISABLE_WABA_ID_DROPDOWN,
	CHANGE_WABA_ID,
	TOGGLE_WABA_CHANGE_MODAL,
	ADD_WABA_ID_OBJECT,
} from '../actions/wabaIdDropdown.action';
import { IWabaIdState } from '../models/root.interface';

const initialState: IWabaIdState = {
	isWhatsappPage: false,
	wabaId: '',
	version: NaN,
	isLaunchPage: false,
	showWabaChangeModal: false,
	possibleWabaId: '',
	wabaIdObject: {},
	possibleWabaVersion: NaN,
};

const wabaIdDropDownReducer = (
	state: IWabaIdState = initialState,
	action: any
): IWabaIdState => {
	switch (action.type) {
		case ENABLE_WABA_ID_DROPDOWN:
			return {
				...state,
				isWhatsappPage: true,
				isLaunchPage: action.isLaunchPage,
			};
		case DISABLE_WABA_ID_DROPDOWN:
			return {
				...state,
				isWhatsappPage: false,
				isLaunchPage: action.isLaunchPage,
			};
		case CHANGE_WABA_ID:
			return {
				...state,
				wabaId: action.wabaId,
				version: action.version
			};
		case TOGGLE_WABA_CHANGE_MODAL:
			return {
				...state,
				possibleWabaId: action.possibleWabaId,
				showWabaChangeModal: action.showWabaChangeModal,
				possibleWabaVersion: action.possibleWabaVersion,
			};
		case ADD_WABA_ID_OBJECT:
			return {
				...state,
				wabaIdObject: action.wabaIdObject,
			};
		default:
			return state;
	}
};

export default wabaIdDropDownReducer;
